import React from "react";
import ReactDOM from "react-dom";

import { IgTypography } from "@intelligems/ig-theme";
import { usePromptInputAttachments } from "@src/components/ai-elements/prompt-input";
import { useExecutionPanelContext } from "@src/features/ai/components/WorkflowEditor/execution/panel/ExecutionPanelContext";

export const DropZoneIndicator = () => {
  const { dropZoneRef, getSlot } = useExecutionPanelContext();
  const { isDraggingFiles } = usePromptInputAttachments();

  if (!isDraggingFiles || !dropZoneRef?.current) return null;

  return ReactDOM.createPortal(
    getSlot("dropZoneIndicator", <Indicator />),
    dropZoneRef.current
  );
};

const Indicator = () => {
  return (
    <div className="pointer-events-none absolute inset-0 z-50 flex items-center justify-center rounded-lg border-2 border-dashed border-primary bg-background/70">
      <IgTypography variant="body1" sx={{ fontWeight: 600 }}>
        Drop files to attach
      </IgTypography>
    </div>
  );
};
